import React from 'react';
import { VivirSinDolorPage } from './pages/VivirSinDolorPage';
export function App() {
  return <VivirSinDolorPage data-id="element-0" />;
}